import React from 'react';
import QuestionCard from './QuestionCard';

const PracticeSection = ({
  practice,
  responses,
  isLocked,
  highlightedQuestionId,
  onAnswerChange,
  onEvidenceChange,
  onFilesSelected,
  onRemoveBackendFile,
  onRetryPendingFile,
  onRemovePendingFile,
  darkMode,
  theme,
}) => {
  return (
    <div className="mb-6">
      <h3 className={`text-xl font-semibold p-3 rounded mb-3 border-l-4 ${darkMode ? 'bg-gray-900 border-orange-500 text-orange-300' : 'bg-orange-50 border-orange-600 text-gray-900'}`}>
        {practice.code && `${practice.code} - `}
        {practice.title}
      </h3>

      {(practice.questions || []).map((q) => {
        const current = responses.find((r) => r.question === q.id) || {
          id: null,
          answer: '',
          evidence: '',
          backendFiles: [],
          newFiles: [],
        };

        return (
          <QuestionCard
            key={q.id}
            question={q}
            response={current}
            isLocked={isLocked}
            highlighted={highlightedQuestionId === q.id}
            onAnswerChange={onAnswerChange}
            onEvidenceChange={onEvidenceChange}
            onFilesSelected={onFilesSelected}
            onRemoveBackendFile={onRemoveBackendFile}
            onRetryPendingFile={onRetryPendingFile}
            onRemovePendingFile={onRemovePendingFile}
            darkMode={darkMode}
            theme={theme}
          />
        );
      })}
    </div>
  );
};

export default PracticeSection;